import { Category } from '../character/allValues';

export default abstract class BaseAttribute {
  public name: string;
  public abbreviation: string;
  public abstract category: Category;
  public description?: string;

  public constructor(name: string) {
    this.name = name;
    this.abbreviation = name
      .toLowerCase()
      .replace(' ', '_')
      .replace(/\(\)/gi, '')
      .replace('&', 'und')
      .replace('ä', 'ae')
      .replace('ö', 'oe')
      .replace('ü', 'ue');
  }

  public abstract getClone();
}
